import {
    apiRequest,
    AcSosioculturalList
} from "../../../../../services/adapters/Assesment/assesmentService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AcSosioculturalList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository